// extracted by mini-css-extract-plugin
export default {"column_chart__body":"columnChart_column_chart__body__KPYr8"};